interface ResponsivePictureProps {
  basePath: string;
  alt: string;
  className?: string;
  eager?: boolean;
  width: number;
  height: number;
  objectPosition?: string;
}

export function ResponsivePicture({
  basePath,
  alt,
  className,
  eager = false,
  width,
  height,
  objectPosition,
}: ResponsivePictureProps) {
  const responsive = basePath.startsWith("/assets/images/products/families/") || basePath === "/assets/images/hero/generated/wear-plate-service-center";
  const srcSet = (format: string) => responsive
    ? [640, 960, 1280].filter(size => size < width).map(size => `${basePath}-${size}.${format} ${size}w`).concat(`${basePath}.${format} ${width}w`).join(", ")
    : `${basePath}.${format}`;
  return (
    <picture className={className}>
      <source srcSet={srcSet("avif")} sizes={responsive ? "(max-width: 680px) 94vw, (max-width: 1080px) 46vw, 600px" : undefined} type="image/avif" />
      <source srcSet={srcSet("webp")} sizes={responsive ? "(max-width: 680px) 94vw, (max-width: 1080px) 46vw, 600px" : undefined} type="image/webp" />
      <img
        src={`${basePath}.jpg`}
        alt={alt}
        width={width}
        height={height}
        loading={eager ? "eager" : "lazy"}
        fetchPriority={eager ? "high" : "auto"}
        decoding="async"
        style={objectPosition ? { objectPosition } : undefined}
      />
    </picture>
  );
}
